const partners = [
  { name: 'Ale Comi', phone: '5215514528815' },
  { name: 'Abel', phone: '5215581183870' },
  { name: 'Xochitl', phone: '5215618415963' },
  { name: 'Enrique', phone: '5215525498457' },
];

const categories = [
  {
    id: 0,
    name: 'Café y Bebidas',
    display: false,
  },
  {
    id: 1,
    name: 'Abarrotes',
    display: false,
  },
  {
    id: 2,
    name: 'Salchichonería',
    display: false,
  },
  {
    id: 3,
    name: 'Frutas y Verduras',
    display: false,
  },
  {
    id: 4,
    name: 'Desechables',
    display: false,
  },
  {
    id: 5,
    name: 'Pan y Galletas',
    display: false,
  },
  {
    id: 6,
    name: 'Bebidas Tradicionales',
    display: false,
  },
  {
    id: 7,
    name: 'Embotellados',
    display: false,
  },
  {
    id: 8,
    name: 'Productos de Limpieza',
    display: false,
  },
  {
    id: 9,
    name: 'Preparación de Alimentos',
    display: false,
  },
  {
    id: 10,
    name: 'Actividades para Cafetería',
    display: false,
  },
];

const rawItems = [
  {
    name: 'Café Gourmet Chiapas',
    label: 'Café Gourmet Chiapas',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Café Gourmet Veracruz',
    label: 'Café Gourmet Veracruz',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Café Especialidad Oaxaca',
    label: 'Café Especialidad Oaxaca',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Café Descafeinado',
    label: 'Café Descafeinado',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Café de Especialidad (otros)',
    label: 'Café de Especialidad (otros)',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Cacao Fermentado',
    label: 'Cacao Fermentado',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Cacao Lavado',
    label: 'Cacao Lavado',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Maíz Blanco',
    label: 'Maíz Blanco',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Maíz Azul',
    label: 'Maíz Azul',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Maíz Rojo',
    label: 'Maíz Rojo',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Achiote',
    label: 'Achiote',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Bolsas de Café (para exhibición)',
    label: 'Bolsas de Café (para exhibición)',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Leche Entera',
    label: 'Leche Entera',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Leche Deslactosada',
    label: 'Leche Deslactosada',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Leche Light',
    label: 'Leche Light',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Leche de Almendras',
    label: 'Leche de Almendras',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Leche de Soya',
    label: 'Leche de Soya',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Leche de Avena',
    label: 'Leche de Avena',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Leche de Coco',
    label: 'Leche de Coco',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Extracto de café de olla',
    label: 'Extracto de café de olla',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Chocolate Blanco',
    label: 'Chocolate Blanco',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Cajeta',
    label: 'Cajeta',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Extracto de Vainilla',
    label: 'Extracto de Vainilla',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Miel',
    label: 'Miel',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Taro',
    label: 'Taro',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Chai Clásico',
    label: 'Chai Clásico',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Chai Manzana-Canela',
    label: 'Chai Manzana-Canela',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Chai Frutos Rojos',
    label: 'Chai Frutos Rojos',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Chai Natural (artesanal)',
    label: 'Chai Natural (artesanal)',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Matcha Natural',
    label: 'Matcha Natural',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Matcha Endulzado',
    label: 'Matcha Endulzado',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Blue Matcha',
    label: 'Blue Matcha',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Pulpa de Café',
    label: 'Pulpa de Café',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Cáscara de Cacao',
    label: 'Cáscara de Cacao',
    categoryId: 0,
    checked: false,
  },
  {
    name: '(Fríos) Concentrado de Mango',
    label: '(Fríos) Concentrado de Mango',
    categoryId: 0,
    checked: false,
  },
  {
    name: '(Fríos) Concentrado de Durazno',
    label: '(Fríos) Concentrado de Durazno',
    categoryId: 0,
    checked: false,
  },
  {
    name: '(Fríos) Concentrado de Toronja',
    label: '(Fríos) Concentrado de Toronja',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Manzanilla-Lavanda',
    label: 'Manzanilla-Lavanda',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Cedrón-Romero',
    label: 'Cedrón-Romero',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Tres Mentas',
    label: 'Tres Mentas',
    categoryId: 0,
    checked: false,
  },
  {
    name: 'Azúcar Blanca',
    label: 'Azúcar Blanca',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Azúcar Mascabado (a granel)',
    label: 'Azúcar Mascabado (a granel)',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Azúcar Mascabado (sobres)',
    label: 'Azúcar Mascabado (sobres)',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Stevia (sobres)',
    label: 'Stevia (sobres)',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Harina',
    label: 'Harina',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Mantequilla',
    label: 'Mantequilla',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Huevos',
    label: 'Huevos',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Pimienta',
    label: 'Pimienta',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Nuez Moscada',
    label: 'Nuez Moscada',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Sal',
    label: 'Sal',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Royal',
    label: 'Royal',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Bicarbonato de Sodio',
    label: 'Bicarbonato de Sodio',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Aceite de maíz',
    label: 'Aceite de maíz',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Clavo',
    label: 'Clavo',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Nueces',
    label: 'Nueces',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Arándanos',
    label: 'Arándanos',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Chocolate Hersheys',
    label: 'Chocolate Hersheys',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Aceite de Oliva',
    label: 'Aceite de Oliva',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Jitomates Deshidratados',
    label: 'Jitomates Deshidratados',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Vinagre de Arándanos',
    label: 'Vinagre de Arándanos',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Vino Tinto',
    label: 'Vino Tinto',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Crema',
    label: 'Crema',
    categoryId: 1,
    checked: false,
  },

  {
    name: 'Piloncillo (Café de Olla)',
    label: 'Piloncillo (Café de Olla)',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Piloncillo (pinole)',
    label: 'Piloncillo (pinole)',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Canela',
    label: 'Canela',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Pasta de Hojaldre',
    label: 'Pasta de Hojaldre',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Chamoy',
    label: 'Chamoy',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Miguelito',
    label: 'Miguelito',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Pechuga de Pavo',
    label: 'Pechuga de Pavo',
    categoryId: 2,
    checked: false,
  },
  {
    name: 'Queso Gouda',
    label: 'Queso Gouda',
    categoryId: 2,
    checked: false,
  },
  {
    name: 'Tocino',
    label: 'Tocino',
    categoryId: 2,
    checked: false,
  },
  {
    name: 'Mezcla 6 Quesos',
    label: 'Mezcla 6 Quesos',
    categoryId: 2,
    checked: false,
  },
  {
    name: 'lechuga',
    label: 'Lechuga',
    categoryId: 3,
    checked: false,
  },
  {
    name: 'Jitomates Cherries',
    label: 'Jitomates Cherries',
    categoryId: 3,
    checked: false,
  },
  {
    name: 'Zanahoria',
    label: 'Zanahoria',
    categoryId: 3,
    checked: false,
  },
  {
    name: 'Pepino',
    label: 'Pepino',
    categoryId: 3,
    checked: false,
  },
  {
    name: 'Cebolla',
    label: 'Cebolla',
    categoryId: 3,
    checked: false,
  },
  {
    name: 'Cebollín',
    label: 'Cebollín',
    categoryId: 3,
    checked: false,
  },
  {
    name: 'Espinacas',
    label: 'Espinacas',
    categoryId: 3,
    checked: false,
  },
  {
    name: 'Poro',
    label: 'Poro',
    categoryId: 3,
    checked: false,
  },
  {
    name: 'Desinfectante de Frutas y Verduras',
    label: 'Desinfectante de Frutas y Verduras',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Vasos 8oz (calientes)',
    label: 'Vasos 8oz (calientes)',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Vasos 12oz (calientes)',
    label: 'Vasos 12oz (calientes)',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Tapas 8oz (calientes)',
    label: 'Tapas 8oz (calientes)',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Tapas 12oz (calientes)',
    label: 'Tapas 12oz (calientes)',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Vasos 12oz (frías)',
    label: 'Vasos 12oz (frías)',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Vasos 16oz (frías)',
    label: 'Vasos 16oz (frías)',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Popotes',
    label: 'Popotes',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Domos Hamburgueseros',
    label: 'Domos Hamburgueseros',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Domos 7x7',
    label: 'Domos 7x7',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Servilletas',
    label: 'Servilletas',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Servitoallas',
    label: 'Servitoallas',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Guantes Negros',
    label: 'Guantes Negros',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Cofias',
    label: 'Cofias',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Brochas para Café',
    label: 'Brochas para Café',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Gis',
    label: 'Gis',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Etiquetas',
    label: 'Etiquetas',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Esponjas para Lavar',
    label: 'Esponjas para Lavar',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Bolsas Papel Kraft (pedidos)',
    label: 'Bolsas Papel Kraft (pedidos)',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Filtros V60',
    label: 'Filtros V60',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Filtros Aeropress',
    label: 'Filtros Aeropress',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Filtros Chemex',
    label: 'Filtros Chemex',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Filtros Clever',
    label: 'Filtros Clever',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Filtros Kalita',
    label: 'Filtros Kalita',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Filtros Sifón Japonés',
    label: 'Filtros Sifón Japonés',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Filtros Origami',
    label: 'Filtros Origami',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Baguettes',
    label: 'Baguettes',
    categoryId: 5,
    checked: false,
  },
  {
    name: 'Galletas de Nutella',
    label: 'Galletas de Nutella',
    categoryId: 5,
    checked: false,
  },
  {
    name: 'Galletas Surtidas',
    label: 'Galletas Surtidas',
    categoryId: 5,
    checked: false,
  },
  {
    name: 'Obleas',
    label: 'Obleas',
    categoryId: 5,
    checked: false,
  },
  {
    name: 'Tostar Cacao Lavado',
    label: 'Tostar Cacao Lavado',
    categoryId: 6,
    checked: false,
  },
  {
    name: 'Tostar Cacao Fermentado',
    label: 'Tostar Cacao Fermentado',
    categoryId: 6,
    checked: false,
  },
  {
    name: 'Tostar Maíz',
    label: 'Tostar Maíz',
    categoryId: 6,
    checked: false,
  },
  {
    name: 'Tascalate',
    label: 'Tascalate',
    categoryId: 6,
    checked: false,
  },
  {
    name: 'Pozol',
    label: 'Pozol',
    categoryId: 6,
    checked: false,
  },
  {
    name: 'Tejate',
    label: 'Tejate',
    categoryId: 6,
    checked: false,
  },
  {
    name: 'Chilate',
    label: 'Chilate',
    categoryId: 6,
    checked: false,
  },
  {
    name: 'Athool',
    label: 'Athool',
    categoryId: 6,
    checked: false,
  },
  {
    name: 'Atlaquetzalli',
    label: 'Atlaquetzalli',
    categoryId: 6,
    checked: false,
  },
  {
    name: 'Atole de Amaranto',
    label: 'Atole de Amaranto',
    categoryId: 6,
    checked: false,
  },
  {
    name: 'Atole Negro',
    label: 'Atole Negro',
    categoryId: 6,
    checked: false,
  },
  {
    name: 'Avenacao',
    label: 'Avenacao',
    categoryId: 6,
    checked: false,
  },
  {
    name: 'Esquiate',
    label: 'Esquiate',
    categoryId: 6,
    checked: false,
  },
  {
    name: 'Tanchucúa',
    label: 'Tanchucúa',
    categoryId: 6,
    checked: false,
  },
  {
    name: 'Itkuy Tombu ',
    label: 'Itkuy Tombu ',
    categoryId: 6,
    checked: false,
  },
  {
    name: 'Bolsas de Cacao (etiqueta Azul)',
    label: 'Bolsas de Cacao (etiqueta Azul)',
    categoryId: 6,
    checked: false,
  },
  {
    name: 'Bolsas de Bebidas Tradicionales (etiqueta rosa)',
    label: 'Bolsas de Bebidas Tradicionales (etiqueta rosa)',
    categoryId: 6,
    checked: false,
  },

  {
    name: 'Delison Maracuyá',
    label: 'Delison Maracuyá',
    categoryId: 7,
    checked: false,
  },
  {
    name: 'Delison Manzana',
    label: 'Delison Manzana',
    categoryId: 7,
    checked: false,
  },
  {
    name: 'Delison Blueberry',
    label: 'Delison Blueberry',
    categoryId: 7,
    checked: false,
  },
  {
    name: 'Delison Durazno',
    label: 'Delison Durazno',
    categoryId: 7,
    checked: false,
  },
  {
    name: 'Búho Soda Kola',
    label: 'Búho Soda Kola',
    categoryId: 7,
    checked: false,
  },
  {
    name: 'Búho Soda Mango-Maracuyá',
    label: 'Búho Soda Mango-Maracuyá',
    categoryId: 7,
    checked: false,
  },
  {
    name: 'Búho Soda Mandarina-Naranja',
    label: 'Búho Soda Mandarina-Naranja',
    categoryId: 7,
    checked: false,
  },
  {
    name: 'Búho Soda Limón-Menta',
    label: 'Búho Soda Limón-Menta',
    categoryId: 7,
    checked: false,
  },
  {
    name: 'Búho Soda Tamarindo-Chile',
    label: 'Búho Soda Tamarindo-Chile',
    categoryId: 7,
    checked: false,
  },
  {
    name: 'Búho Soda Guayaba-Cardamomo',
    label: 'Búho Soda Guayaba-Cardamomo',
    categoryId: 7,
    checked: false,
  },
  {
    name: 'Búho Soda Jamaica-Granada',
    label: 'Búho Soda Jamaica-Granada',
    categoryId: 7,
    checked: false,
  },
  {
    name: 'Agua Mineral',
    label: 'Agua Mineral',
    categoryId: 7,
    checked: false,
  },
  {
    name: 'Botellas de Agua Natural',
    label: 'Botellas de Agua Natural',
    categoryId: 7,
    checked: false,
  },
  {
    name: 'Limpiador Multiusos',
    label: 'Limpiador Multiusos',
    categoryId: 8,
    checked: false,
  },
  {
    name: 'Jabón para trastes (verde)',
    label: 'Jabón para trastes (verde)',
    categoryId: 8,
    checked: false,
  },
  {
    name: 'Jabón para manos',
    label: 'Jabón para manos',
    categoryId: 8,
    checked: false,
  },

  {
    name: 'Desengrasante',
    label: 'Desengrasante',
    categoryId: 8,
    checked: false,
  },
  {
    name: 'Sanitas',
    label: 'Sanitas',
    categoryId: 8,
    checked: false,
  },
  {
    name: 'Papel Higiénico',
    label: 'Papel Higiénico',
    categoryId: 8,
    checked: false,
  },
  {
    name: 'Cloro',
    label: 'Cloro',
    categoryId: 8,
    checked: false,
  },
  {
    name: 'Alcohol sanitizante',
    label: 'Alcohol sanitizante',
    categoryId: 8,
    checked: false,
  },
  {
    name: 'Alcohol Industrial (sifón japonés)',
    label: 'Alcohol Industrial (sifón japonés)',
    categoryId: 8,
    checked: false,
  },
  {
    name: 'Cafiza',
    label: 'Cafiza',
    categoryId: 8,
    checked: false,
  },
  {
    name: 'Rinza',
    label: 'Rinza',
    categoryId: 8,
    checked: false,
  },
  {
    name: '🥣 *Quiche Espinacas*',
    label: 'Quiche Espinacas',
    categoryId: 9,
    checked: false,
  },
  {
    name: '🥣 *Quiche Pechuga de Pavo*',
    label: 'Quiche Pechuga de Pavo',
    categoryId: 9,
    checked: false,
  },
  {
    name: '🥣 *Pastel de Zanahoria*',
    label: 'Pastel de Zanahoria',
    categoryId: 9,
    checked: false,
  },
  {
    name: '🥣 *Pastel de Chocolate*',
    label: 'Pastel de Chocolate',
    categoryId: 9,
    checked: false,
  },
  {
    name: '🥣 *Panqué de Plátano*',
    label: 'Panqué de Plátano',
    categoryId: 9,
    checked: false,
  },
  {
    name: '🥣 *Tarta de manzanas con peras al vino tinto*',
    label: 'Tarta de manzanas con peras al vino tinto',
    categoryId: 9,
    checked: false,
  },
  {
    name: '🥣 *Cebollas caramelizadas*',
    label: 'Cebollas caramelizadas',
    categoryId: 9,
    checked: false,
  },
  {
    name: '🥣 *Pimientos a la mantequilla*',
    label: 'Pimientos a la mantequilla',
    categoryId: 9,
    checked: false,
  },
  {
    name: '🥣 *Aderezo de jitomates deshidratados*',
    label: 'Aderezo de jitomates deshidratados',
    categoryId: 9,
    checked: false,
  },
  {
    name: '🥣 *Desinfectar lechuga*',
    label: 'Desinfectar lechuga',
    categoryId: 9,
    checked: false,
  },
  {
    name: '🥣 *Zanahoria rallada*',
    label: 'Zanahoria rallada',
    categoryId: 9,
    checked: false,
  },
  {
    name: '🥣 *Betún de Pastel de Zanahoria*',
    label: 'Betún de Pastel de Zanahoria',
    categoryId: 9,
    checked: false,
  },
  {
    name: '🪄 *Limpiar Baño (bote, excusado, lavabo)*',
    label: 'Limpiar Baño (bote, excusado, lavabo)',
    categoryId: 10,
    checked: false,
  },
  {
    name: '🪄 *Limpiar y ordernar vitrina*',
    label: 'Limpiar y ordernar vitrina',
    categoryId: 10,
    checked: false,
  },
  {
    name: '🪄 *Limpiar horno grande*',
    label: 'Limpiar horno grande',
    categoryId: 10,
    checked: false,
  },
  {
    name: '🪄 *Limpiar horno chico*',
    label: 'Limpiar horno chico',
    categoryId: 10,
    checked: false,
  },
  {
    name: '🪄 *Limpiar y ordenar bodega*',
    label: 'Limpiar y ordenar bodega',
    categoryId: 10,
    checked: false,
  },
  {
    name: '🪄 *Limpiar espacio debajo de barra*',
    label: 'Limpiar espacio debajo de barra',
    categoryId: 10,
    checked: false,
  },
  {
    name: '🪄 *Limpiar Estante*',
    label: 'Limpiar Estante',
    categoryId: 10,
    checked: false,
  },
  {
    name: '🪄 *Limpiar espacio de polvos*',
    label: 'Limpiar espacio de polvos',
    categoryId: 10,
    checked: false,
  },
  {
    name: '🪄 *Limpiar Barra de Café*',
    label: 'Limpiar Barra de Café',
    categoryId: 10,
    checked: false,
  },
  {
    name: '🪄 *Limpiar Toldo*',
    label: 'Limpiar Toldo',
    categoryId: 10,
    checked: false,
  },
  {
    name: '🪄 *Limpiar Máquina de Espresso (atrás, debajo y con cafiza)*',
    label: 'Limpiar Máquina de Espresso (atrás, debajo y con cafiza)',
    categoryId: 10,
    checked: false,
  },
  {
    name: 'Queso Philadelfia',
    label: 'Queso Philadelfia',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Agua Epura',
    label: 'Agua Epura',
    categoryId: 1,
    checked: false,
  },
  {
    name: 'Velas',
    label: 'Velas',
    categoryId: 1,
    checked: false,
  },
  {
    name: '🪄 *Limpiar Botes de Basura*',
    label: 'Limpiar Botes de Basura',
    categoryId: 10,
    checked: false,
  },
  {
    name: 'Pimientos',
    label: 'Pimientos',
    categoryId: 3,
    checked: false,
  },
  {
    name: 'Plátanos',
    label: 'Plátanos',
    categoryId: 3,
    checked: false,
  },
  {
    name: '🪄 *Cambiar Pizarrón*',
    label: 'Cambiar Pizarrón',
    categoryId: 10,
    checked: false,
  },
  {
    name: '💸 *Cambio*',
    label: 'Pedir Cambio',
    categoryId: 10,
    checked: false,
  },
  {
    name: '🏥 *Completar Botiquin*',
    label: 'Completar Botiquín',
    categoryId: 10,
    checked: false,
  },
  {
    name: 'Guayabas',
    label: 'Guayabas',
    categoryId: 3,
    checked: false,
  },
  {
    name: 'Peras',
    label: 'Peras',
    categoryId: 3,
    checked: false,
  },
  {
    name: 'Manzanas',
    label: 'Manzanas',
    categoryId: 3,
    checked: false,
  },
  {
    name: 'Limones',
    label: 'Limones',
    categoryId: 3,
    checked: false,
  },
  {
    name: 'Tenedores',
    label: 'Tenedores',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Fajillas',
    label: 'Fajillas',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Playo',
    label: 'Playo',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Bolsas para Basura (chicas)',
    label: 'Bolsas para Basura (chicas)',
    categoryId: 8,
    checked: false,
  },
  {
    name: 'Bolsas para Basura (grandes)',
    label: 'Bolsas para Basura (grandes)',
    categoryId: 8,
    checked: false,
  },
  {
    name: 'Portavasos',
    label: 'Portavasos',
    categoryId: 4,
    checked: false,
  },
  {
    name: 'Cuchillos',
    label: 'Cuchillos',
    categoryId: 4,
    checked: false,
  },
];

const itemList = rawItems.map((item, index) => ({
  id: String(index + 1),
  name: item.name,
  label: item.label,
  categoryId: item.categoryId,
  messageText: item.name,
}));

export { itemList, categories, partners };
